<div *ngIf="attrs.type==='sectionText'">
  <strong>
    --{{attrs.publishedName}}--
  </strong>
  <hr />
</div>
<!--<div style="background-color:red" *ngIf="attrs.isError">eee</div>-->
<div class="form-group attr-width" *ngIf="attrs.show && attrs.type!=='sectionText'"
     [ngStyle]="attrs.isError? {'background-color': '#f2dfdf','height':'80px;'} : {'height':'80px'}">
  <!--style="background-color: #f2dfdf;height: 80px;">-->

  <div *ngIf="attrs.type==='switch' &&  attrs.show" style="height:100%;display:flex;align-content:center;justify-content:center">
    <div>
      <label class="k-checkbox-label" for="ch5">{{attrs.publishedName}}</label>&nbsp;&nbsp;
      <kendo-switch onLabel="Yes"
                    offLabel="No"
                    [(ngModel)]="checked"
                    (valueChange)="executeMacro(attrs)"></kendo-switch>
    </div>
  </div>
  <div *ngIf="attrs.type==='text' &&  attrs.show">
    <label for="{{attrs.publishedName}}">{{attrs.publishedName}}</label>
    <input type="text" class="form-control"
           (change)="executeMacro(attrs)"
           [disabled]="disabled"
           [(ngModel)]="attrs.value">
  </div>
  <div *ngIf="attrs.type==='readOnlyText' &&  attrs.show">
    <label style="font-weight:bold">{{attrs.publishedName}}</label><br />
    <label>{{attrs.value}}</label>
  </div>
  <div *ngIf="attrs.type==='number' &&  attrs.show">
    <label for="{{attrs.publishedName}}">{{attrs.publishedName}}</label>
    <input type="text" class="form-control"
           [disabled]="disabled"
           [(ngModel)]="attrs.value">
  </div>
  <div *ngIf="attrs.type==='list' &&  attrs.show">
    <label for="{{attrs.publishedName}}">{{attrs.publishedName}}</label>
    <select class="kendoInput form-control"
            name="attrs.publishedName"
            [(ngModel)]="attrs.value"
            [disabled]="disabled"
            (change)="executeMacro(attrs)">
      <!--<option [ngValue]="-99" selected>--Please Select--</option>-->
      <!--<option [ngValue]="null" disabled>Choose your profile</option>
      <option *ngFor="let prf of allProfiles" [ngValue]="prf">
        {{ prf.prName }}
      </option>-->

      <ng-container *ngFor="let option of attrs.options;let optionIndex=index">
        <option [ngValue]="''" *ngIf="optionIndex===0">--Please Select--</option>
        <option *ngIf="option.show" [ngValue]="option.value">
          {{option.description}}
        </option>
      </ng-container>
    </select>
  </div>
  <div *ngIf="attrs.type==='radio' && attrs.show">
    <input type="radio"
           id="foo" name="a"
           [(ngModel)]="attrs.value"
           [value]="'Non-Transom'"
           (change)="executeMacro(attrs)"
           [disabled]="disabled"
           kendoRadioButton *ngIf="attrs.options[0].show" />
    <label class="k-radio-label" for="foo" *ngIf="attrs.options[0].show">{{attrs.options[0].description}}</label>
    <input type="radio" id="foo1" name="a"
           [(ngModel)]="attrs.value"
           [value]="'Transom'"
           (change)="executeMacro(attrs)"
           [disabled]="disabled"
           kendoRadioButton *ngIf="attrs.options[1].show" />
    <label class="k-radio-label" for="foo1" *ngIf="attrs.options[1].show">{{attrs.options[1].description}}</label>
  </div>
</div>


